module.exports = __webpack_public_path__ + "static/Slider8-68ff5a2a9243a22ee28f9c9d5a6edcbc.jpg";